import '../instrument';
import 'core-js/features/array/at';

import { Buffer } from 'buffer';

import './index.css';

// i18n
import './locales/i18n';

// scroll bar
import 'simplebar/src/simplebar.css';

// editor
import 'react-quill-new/dist/quill.snow.css';

// mui x-grid
import { LicenseInfo } from '@mui/x-license';

import './index.css';
import { createRoot } from 'react-dom/client';

import App from './App';
import { XGRID_LICENSE_KEY } from './config.js';
import { installStaleChunkReload } from './utils/staleChunkReload';

installStaleChunkReload();

// Ensure 'global' is available in Vite environment
// Reference: https://stackoverflow.com/a/73208485
window.global ||= window;

window.Buffer = Buffer;

// ----------------------------------------------------------------------

LicenseInfo.setLicenseKey(XGRID_LICENSE_KEY);

// ----------------------------------------------------------------------

// Register service worker for browser notifications
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
